export default __webpack_public_path__ + "static/media/2457.858ef7e2.png";